import { useMutation } from '@tanstack/react-query'

import { revokeIntegration } from '@/services/revoke-integration'

export const useRevokeIntegration = () => {
  const mutation = useMutation({ mutationFn: revokeIntegration })

  return mutation
}
